// Google Ads Performance Report Data - March 2026
// EXACT numbers from the original reports - DO NOT MODIFY

export const reportsData = {
  "Poplar Creek": {
    title: "Poplar Creek",
    period: "March 2026",
    snapshot: {
      impressions: { value: 6529, label: "Impressions" },
      clicks: { value: 577, label: "Clicks" },
      ctr: { value: 8.84, label: "CTR", suffix: "%" },
      avgCpc: { value: 1.54, label: "Avg CPC", prefix: "$" },
      conversions: { value: 25, label: "Conversions" },
      conversionRate: { value: 4.33, label: "Conv. Rate", suffix: "%" },
      costPerConversion: { value: 35.48, label: "Cost/Conv", prefix: "$" },
      spend: { value: 886.91, label: "Total Spend", prefix: "$" }
    },
    weeklyComparison: {
      first7Days: {
        label: "First 7 Days",
        impressions: 2176,
        clicks: 177,
        ctr: 8.13,
        avgCpc: 1.04,
        conversions: 4,
        conversionRate: 2.26,
        costPerConversion: 45.85,
        spend: 183
      },
      last7Days: {
        label: "Last 7 Days",
        impressions: 2532,
        clicks: 211,
        ctr: 8.33,
        avgCpc: 1.98,
        conversions: 13,
        conversionRate: 6.16,
        costPerConversion: 32.13,
        spend: 417.75
      }
    },
    changes: {
      impressions: { value: 16, isPositive: true },
      clicks: { value: 19, isPositive: true },
      ctr: { value: null, isPositive: true, label: "Improved" },
      avgCpc: { value: null, isPositive: false, label: "Increased (Scaling)" },
      conversions: { value: 225, isPositive: true },
      conversionRate: { value: 173, isPositive: true },
      costPerConversion: { value: -30, isPositive: true },
      spend: { value: null, isPositive: null, label: "Increased" }
    },
    highlights: [
      { title: "Strong Growth in Conversions", description: "Conversions increased from 4 to 13, reflecting a 225% improvement.", metric: "+225%", isPositive: true },
      { title: "Improved Conversion Efficiency", description: "Conversion rate improved from 2.26% to 6.16%, showing higher quality traffic.", metric: "+173%", isPositive: true },
      { title: "Reduced Cost per Conversion", description: "Cost per conversion decreased by 30%, from $45.85 to $32.13.", metric: "-30%", isPositive: true },
      { title: "Effective Campaign Expansion", description: "Shift from 1 to 3 campaigns (Generic, Dynamic, Brand) enabled broader reach.", metric: "3x", isPositive: true }
    ],
    campaigns: [
      { name: "Generic Campaign", description: "Primary driver of traffic and conversions", status: "active" },
      { name: "Dynamic Campaign", description: "Strong conversion rate, high-intent traffic", status: "growing" },
      { name: "Brand Campaign", description: "Capturing branded searches, protecting brand presence", status: "active" }
    ],
    forecast: {
      impressions: "2,600 - 2,800",
      clicks: "220 - 240",
      conversions: "14 - 16",
      conversionRate: "6% - 7%",
      costPerConversion: "$30 - $32",
      note: "Based on last 7 days trend showing 13 conversions at 6.16% conversion rate"
    }
  },
  "University Court": {
    title: "University Court",
    period: "March 2026",
    snapshot: {
      impressions: { value: 6783, label: "Impressions" },
      clicks: { value: 747, label: "Clicks" },
      ctr: { value: 11.01, label: "CTR", suffix: "%" },
      avgCpc: { value: 2.08, label: "Avg CPC", prefix: "$" },
      conversions: { value: 10, label: "Conversions" },
      conversionRate: { value: 1.34, label: "Conv. Rate", suffix: "%" },
      costPerConversion: { value: 155.73, label: "Cost/Conv", prefix: "$" },
      spend: { value: 1557.30, label: "Total Spend", prefix: "$" }
    },
    weeklyComparison: {
      first7Days: {
        label: "First 7 Days",
        impressions: 1864,
        clicks: 183,
        ctr: 9.82,
        avgCpc: 1.88,
        conversions: 0,
        conversionRate: 0,
        costPerConversion: 0,
        spend: 344.78
      },
      last7Days: {
        label: "Last 7 Days",
        impressions: 2631,
        clicks: 283,
        ctr: 10.76,
        avgCpc: 1.58,
        conversions: 9,
        conversionRate: 3.18,
        costPerConversion: 49.60,
        spend: 446.08
      }
    },
    changes: {
      impressions: { value: 41, isPositive: true },
      clicks: { value: 55, isPositive: true },
      ctr: { value: 10, isPositive: true },
      avgCpc: { value: -16, isPositive: true },
      conversions: { value: null, isPositive: true, label: "0 → 9" },
      conversionRate: { value: null, isPositive: true, label: "0% → 3.18%" },
      costPerConversion: { value: null, isPositive: true, label: "$49.60" },
      spend: { value: 29, isPositive: null }
    },
    highlights: [
      { title: "Conversions From Zero to Nine", description: "Went from 0 conversions in the first 7 days to 9 conversions in the last 7 days.", metric: "0→9", isPositive: true },
      { title: "Traffic Growth & Engagement", description: "Clicks increased by 55% (183 to 283) and impressions grew by 41%.", metric: "+55%", isPositive: true },
      { title: "Improved Cost Efficiency", description: "Average CPC decreased from $1.88 to $1.58, a 16% reduction.", metric: "-16%", isPositive: true },
      { title: "Strong Conversion Rate Growth", description: "Conversion rate went from 0% to 3.18%, showing highly qualified traffic.", metric: "3.18%", isPositive: true }
    ],
    campaigns: [
      { name: "Generic Campaign", description: "Main driver of clicks and impressions", status: "active" },
      { name: "Dynamic Search Campaign", description: "Strong CTR and early conversions indicate high-intent traffic", status: "growing" },
      { name: "Brand Campaign", description: "Capturing branded searches, protecting brand presence", status: "active" }
    ],
    forecast: {
      impressions: "2,700 - 2,900",
      clicks: "290 - 320",
      conversions: "10 - 12",
      conversionRate: "3% - 4%",
      costPerConversion: "$45 - $50",
      note: "Based on last 7 days trend showing 9 conversions at 3.18% conversion rate"
    }
  }
};

// Chart data formatters
export const getWeeklyComparisonChartData = (report) => {
  const { first7Days, last7Days } = report.weeklyComparison;
  return [
    { metric: "Impressions", "First 7 Days": first7Days.impressions, "Last 7 Days": last7Days.impressions },
    { metric: "Clicks", "First 7 Days": first7Days.clicks, "Last 7 Days": last7Days.clicks },
    { metric: "Conversions", "First 7 Days": first7Days.conversions, "Last 7 Days": last7Days.conversions },
  ];
};

export const getSpendComparisonData = (report) => {
  const { first7Days, last7Days } = report.weeklyComparison;
  return [
    { metric: "Spend ($)", "First 7 Days": first7Days.spend, "Last 7 Days": last7Days.spend },
  ];
};

export const getCTRComparisonData = (report) => {
  const { first7Days, last7Days } = report.weeklyComparison;
  return [
    { metric: "CTR (%)", "First 7 Days": first7Days.ctr, "Last 7 Days": last7Days.ctr },
    { metric: "Conv. Rate (%)", "First 7 Days": first7Days.conversionRate, "Last 7 Days": last7Days.conversionRate },
  ];
};

export const getCostComparisonData = (report) => {
  const { first7Days, last7Days } = report.weeklyComparison;
  return [
    { metric: "Avg CPC ($)", "First 7 Days": first7Days.avgCpc, "Last 7 Days": last7Days.avgCpc },
    { metric: "Cost/Conv ($)", "First 7 Days": first7Days.costPerConversion, "Last 7 Days": last7Days.costPerConversion },
  ];
};

export const getMetricsDistribution = (report) => {
  const { first7Days, last7Days } = report.weeklyComparison;
  return [
    { name: "First 7 Days Spend", value: first7Days.spend, fill: "#404040" },
    { name: "Last 7 Days Spend", value: last7Days.spend, fill: "#F59E0B" },
  ];
};
